// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SpacePermissionsPopup__content-e7e4c1 {
  padding: 8px 0px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  flex: 1;
  overflow: auto;
}

.SpacePermissionsPopup__caption-a0ad62 {
  font: var(--font-button);
  letter-spacing: var(--font-spacing-button);
  color: var(--base-80);
  padding: 16px 24px 0;
}

.SpacePermissionsPopup__switch-f65372 {
  flex-shrink: 0;
  padding: 12px 24px;
}

.SpacePermissionsPopup__switch-with-description-b491e2 {
  padding: 8px 24px;
}

.SpacePermissionsPopup__footer-b679fa {
  flex: 0 0 auto;
  display: flex;
  flex-direction: column;
  padding: 16px 24px 16px;
}

.SpacePermissionsPopup__button-c0043a {
  align-self: flex-end;
}`, "",{"version":3,"sources":["webpack://./src/main/PopupManager/Popups/SpacePermissionsPopup/SpacePermissionsPopup.styles.m.css"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,oBAAA;EACA,OAAA;EACA,cAAA;AACF;;AAEA;EACE,wBAAA;EACA,0CAAA;EACA,qBAAA;EACA,oBAAA;AACF;;AAEA;EACE,cAAA;EACA,kBAAA;AACF;;AAEA;EACE,iBAAA;AACF;;AAEA;EACE,cAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;AACF;;AAEA;EACE,oBAAA;AACF","sourcesContent":[".content {\n  padding: 8px 0px;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  flex: 1;\n  overflow: auto;\n}\n\n.caption {\n  font: var(--font-button);\n  letter-spacing: var(--font-spacing-button);\n  color: var(--base-80);\n  padding: 16px 24px 0;\n}\n\n.switch {\n  flex-shrink: 0;\n  padding: 12px 24px;\n}\n\n.switch-with-description {\n  padding: 8px 24px;\n}\n\n.footer {\n  flex: 0 0 auto;\n  display: flex;\n  flex-direction: column;\n  padding: 16px 24px 16px;\n}\n\n.button {\n  align-self: flex-end;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `SpacePermissionsPopup__content-e7e4c1`,
	"caption": `SpacePermissionsPopup__caption-a0ad62`,
	"switch": `SpacePermissionsPopup__switch-f65372`,
	"switch-with-description": `SpacePermissionsPopup__switch-with-description-b491e2`,
	"switchWithDescription": `SpacePermissionsPopup__switch-with-description-b491e2`,
	"footer": `SpacePermissionsPopup__footer-b679fa`,
	"button": `SpacePermissionsPopup__button-c0043a`
};
module.exports = ___CSS_LOADER_EXPORT___;
